/** Workspace, settings and integration contracts — spec §6.2, §7.7, F21. */
import { z } from 'zod';
import { objectIdSchema } from './common.js';
import { HHMM, timezoneSchema } from './user.js';
export const holidaySchema = z.object({
    date: z.coerce.date(),
    name: z.string().min(1).max(120),
});
export const workspaceSettingsSchema = z.object({
    allowedInviteDomains: z.array(z.string().min(1).max(120)).max(20).default([]),
    defaultProjectVisibility: z.enum(['workspace', 'private']).default('private'),
    requireTwoFactorForAdmins: z.boolean().default(true),
    taskDeleteGraceMinutes: z.number().int().min(0).max(1440).default(15),
});
export const updateWorkspaceSchema = z
    .object({
    name: z.string().min(1).max(120),
    logoUrl: z.string().url().nullish(),
    // V10 §4 — the same validated schema the profile uses. A workspace
    // timezone `Intl` rejects is what ended the attendance sweep in §1.
    timezone: timezoneSchema,
    workingDays: z.array(z.number().int().min(0).max(6)).max(7),
    workingHours: z.object({ start: z.string().regex(HHMM), end: z.string().regex(HHMM) }),
    holidays: z.array(holidaySchema).max(60),
    fiscalYearStartMonth: z.number().int().min(1).max(12),
    settings: workspaceSettingsSchema.partial(),
})
    .strict()
    .partial();
export const transferOwnershipSchema = z
    .object({ toUserId: objectIdSchema, password: z.string().min(1) })
    .strict();
/** Secrets are write-only — never returned by the API (§F21). */
export const updateIntegrationsSchema = z
    .object({
    brevo: z
        .object({
        apiKey: z.string().min(1).optional(),
        senderEmail: z.string().email().optional(),
        senderName: z.string().min(1).max(80).optional(),
        enabled: z.boolean().optional(),
    })
        .strict()
        .optional(),
    whatsapp: z
        .object({
        phoneNumberId: z.string().min(1).optional(),
        accessToken: z.string().min(1).optional(),
        wabaId: z.string().min(1).optional(),
        templates: z.record(z.string()).optional(),
        enabled: z.boolean().optional(),
    })
        .strict()
        .optional(),
    s3: z
        .object({
        bucket: z.string().min(1).optional(),
        region: z.string().min(1).optional(),
        accessKeyId: z.string().min(1).optional(),
        secretAccessKey: z.string().min(1).optional(),
        publicBaseUrl: z.string().url().optional(),
    })
        .strict()
        .optional(),
    push: z
        .object({
        vapidPublicKey: z.string().min(1).optional(),
        vapidPrivateKey: z.string().min(1).optional(),
        contact: z.string().min(1).optional(),
        enabled: z.boolean().optional(),
    })
        .strict()
        .optional(),
})
    .strict();
export const MASKED_SECRET = '••••••••';
//# sourceMappingURL=workspace.js.map